import CityManagementPage from "./shared/CityManagementPage";
import { allCityConfigs } from "./shared/cityConfigExtended";

export default function Oxford() {
  return <CityManagementPage config={allCityConfigs.oxford} />;
}